<template>
  <component :is="dashboardComponent" />
</template>

<script>
import store from '@/store/store'

const getUserRole = () => store.state.user?.role || store.state.role || localStorage.getItem('role')
const AccountantDashboard = () => import('@/views/AccountantDashboard.vue')
const SalesDashboard = () => import('@/views/SalesDashboard.vue')
const HomeDashboard = () => import('@/views/Home.vue')

const redirectIfAdminDeveloper = next => {
  if (getUserRole() === 'admin_developer') {
    next({ name: 'invoice-list-direx' })
  } else {
    next()
  }
}

export default {
  name: 'DashboardWrapper',
  beforeRouteEnter(to, from, next) {
    redirectIfAdminDeveloper(next)
  },
  beforeRouteUpdate(to, from, next) {
    redirectIfAdminDeveloper(next)
  },
  computed: {
    dashboardComponent() {
      const role = getUserRole()
      if (role === 'accountant') {
        return AccountantDashboard
      }
      if (role === 'sales') {
        return SalesDashboard
      }
      return HomeDashboard
    },
  },
}
</script>
